import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '@contexts/auth/AuthContext';
import RememberingRedirect from '@components/auth/RememberingRedirect';

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return <div>Loading...</div>;
  }

  // Not authenticated - go to login
  if (!isAuthenticated) {
    return <RememberingRedirect to="/login" />;
  }

  // Account-status enforcement (Pending/Rejected/Deleted) is handled defensively
  // by the gate in App.tsx, which forces a sign-out. By the time an
  // authenticated route renders, the session is Active.
  return <Outlet />;
};

export default ProtectedRoute;
